/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import React                    from 'react';
import Popover                  from 'components/Popover/Popover.react';
import styles                   from './PreLoader.scss';

export default class PreLoader extends React.Component {
  constructor(props) {
    super();
    this.state = {};

    this.timer = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.close) {
      this.setState({
        close: nextProps.close
      });

      let self = this;

      this.timer = setTimeout(() => {
        self.setState({
          hide: true
        });
      }, 1000);
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }


  render() {
    let loader = (
      <div className={[
        this.props.customPreLoaderClass ? this.props.customPreLoaderClass : null,
        styles.preLoader,
        this.state.hideSidebar ? styles.hideSidebar : null,
        this.state.hideToolbar ? styles.hideToolbar : null,
        this.props.loading ? null : styles.loading
        ].join(' ')}>
        <div className={styles.children}>
          {this.props.children}
        </div>
        <div className={[styles.loaderWrapper, this.props.customLoaderWrapperClass ? this.props.customLoaderWrapperClass : null,].join(' ')}>
          <div className={styles.loader}></div>
        </div>
      </div>
    );

    return (
      this.props.inner
        ?
          <Popover modal={true}>
            {loader}
          </Popover>
        :
          loader
    );
  }
}
